module.exports = __webpack_public_path__ + "static/The_Swan-f60b733dd10d1646decc201de9ade934.wav";